<template>
    <div>
        <v-card-title :class="[{'pt-3': $vuetify.breakpoint.smAndDown},
                               {'pt-2': $vuetify.breakpoint.mdAndUp}, 'px-3']">
            Doppelstart-Kontrolle
        </v-card-title>
        <v-card-subtitle class="px-3 pb-2">
            {{landesverbandLocal.name}} {{sportJahr.replace('_', '/')}}
        </v-card-subtitle>
        <doppel-start-tab :doppelstart-docs="doppelstarts"></doppel-start-tab>
    </div>
</template>

<script>
    import FirebaseRead from "@/services/database/firebaseRead";
    import DoppelStartTab from "./doppelstartTab";

    export default {
        components: {DoppelStartTab},
        name: "doppel-start",
        props: ['sportJahr', 'lvId'],
        computed: {
            landesverbandLocal(){
                return this.lvId !== 'NationaleLigen' ? this.$store.state.local.landesverbaende
                        .find(lv => lv.nameShort.trim() === this.lvId) :
                    this.$store.state.local.nationaleLigen;
            },
        },
        data: () => ({
            doppelstarts: [],
        }),
        created(){
            this.loadDoppelStarts();
        },
        methods: {
            async loadDoppelStarts(){
                this.doppelstarts = await FirebaseRead.readDocList(
                    'doppelstarts', {
                        field: 'searchKeysLV',
                        operator: 'array-contains',
                        value: this.sportJahr + '_' + this.landesverbandLocal.id,
                    }
                )
            }
        },
        watch: {
            sportJahr(){
                this.loadDoppelStarts();
            }
        }
    }
</script>

<style scoped>

</style>